import { render } from "./AppLayout_6_6.vue?vue&type=template&id=2952f8ee&scoped=true"
import script from "./AppLayout_6_6.vue?vue&type=script&lang=js"
export * from "./AppLayout_6_6.vue?vue&type=script&lang=js"

import "./AppLayout_6_6.vue?vue&type=style&index=0&id=2952f8ee&scoped=true&lang=css"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2952f8ee"]])

export default __exports__